export default __webpack_public_path__ + "static/media/bg-gradient.32cfbb91.png";